module.exports = __webpack_public_path__ + "static/media/scanner.c00e81bf.svg";